(() => {
  if (customElements.get('hom-toilet-configurator')) return;
  class ToiletConfigurator extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.config = JSON.parse(this.querySelector('[data-config]').textContent);
      this.text = JSON.parse(this.querySelector('[data-text]').textContent);
      this.addEventListener('input', () => this.update());
      const previewWood = new URL(location.href).searchParams.get('houtsoort');
      if (previewWood) {
        for (const option of this.querySelectorAll('[data-wood]'))
          option.checked = option.dataset.woodHandle === previewWood;
        if (!this.querySelector('[data-wood]:checked')) this.querySelector('[data-wood]').checked = true;
      }
      try {
        const key = 'hom-simple-selection-' + this.config.productKind;
        const saved = JSON.parse(sessionStorage.getItem(key) || 'null');
        sessionStorage.removeItem(key);
        if (saved && saved.until > Date.now()) {
          for (const name of ['length','depth','thickness','skewLeft','skewRight'])
            if (saved[name] != null) this.querySelector('[name="' + name + '"]').value = saved[name];
          this.querySelector('[name="shape"]').checked = saved.shape === true;
          for (const option of this.querySelectorAll('[data-finish]')) option.checked = option.value === saved.finish;
        }
      } catch (_) { /* Storage is optional. */ }
      this.addEventListener('change', event => {
        this.update();
        if (!event.target.matches('[data-wood]')) return;
        const label = event.target.closest('label');
        const wood = JSON.parse(label.querySelector('[data-wood-config]').textContent);
        // Real product URLs once available; unpublished choices remain in the draft preview.
        if (wood.productUrl && new URL(wood.productUrl, location.origin).pathname !== location.pathname) {
          try {
            const saved = {until: Date.now() + 60000, shape:this.querySelector('[name="shape"]').checked,
              finish:this.querySelector('[data-finish]:checked').value};
            for (const name of ['length','depth','thickness','skewLeft','skewRight']) saved[name] = this.querySelector('[name="'+name+'"]').value;
            sessionStorage.setItem('hom-simple-selection-' + this.config.productKind, JSON.stringify(saved));
          } catch (_) { /* Navigation still works without storage. */ }
          const url = new URL(wood.productUrl, location.origin);
          const preview = new URL(location.href).searchParams.get('preview_theme_id');
          if (preview) url.searchParams.set('preview_theme_id', preview);
          location.assign(url.href);
        }
      });
      this.querySelector('[data-add]').addEventListener('click', () => {
        this.update();
        if (!this.orderItem) return;
        try {
          if (!window.HomCart) throw Error(this.text.unavailable);
          window.HomCart.add(this.orderItem);
        } catch (error) { this.querySelector('[data-errors]').textContent = error.message; }
      });
      this.update();
    }
    syncCabinetThickness() {
      if (!this.config.isCabinetTop) return;
      const length = Number(this.querySelector('[name="length"]').value);
      const restricted = Number.isFinite(length) && length > 1810;
      const thickness = this.querySelector('[name="thickness"]');
      for (const option of thickness.options)
        option.disabled = restricted && Number(option.value) < 30;
      if (restricted && Number(thickness.value) < 30) thickness.value = "30";
      const note = this.querySelector('[data-thickness-note]');
      if (note) note.hidden = !restricted;
    }
    update() {
      this.orderItem = null;
      this.querySelector('[data-add]').disabled = true;
      this.syncCabinetThickness();
      const selectedProduct = this.querySelector('[data-wood]:checked')?.closest('label');
      if (selectedProduct) {
        const product = JSON.parse(selectedProduct.querySelector('[data-wood-config]').textContent);
        this.selectedProduct = product;
        const title = this.closest('section')?.querySelector('[data-product-title]');
        if (title) title.textContent = product.productTitle;
        const content = this.querySelector('[data-product-content]');
        if (content && content.dataset.productId !== product.productId) {
          content.replaceChildren(selectedProduct.querySelector('[data-product-description]').content.cloneNode(true));
          content.dataset.productId = product.productId;
        }
      }
      const pickupNote = this.querySelector('[data-pickup-note]');
      if (pickupNote) {
        const selected = this.querySelector('[data-wood]:checked')?.closest('label');
        const wood = selected ? JSON.parse(selected.querySelector('[data-wood-config]').textContent) : {};
        pickupNote.hidden = wood.pickupOnly !== true;
        this.dataset.pickupOnly = String(wood.pickupOnly === true);
      }
      const field = name => this.querySelector('[name="' + name + '"]');
      const number = name => field(name).value.trim() === '' ? NaN : Number(field(name).value);
      const shaped = !this.config.isCabinetTop && field('shape').checked;
      this.querySelector('[data-shape]').hidden = !shaped;
      const s = { length: number('length'), depth: number('depth'), thickness: number('thickness'),
        skewLeft: shaped ? number('skewLeft') : 0, skewRight: shaped ? number('skewRight') : 0,
        finish: this.querySelector('[data-finish]:checked')?.value || 'untreated',
        quantity: 1, lighting: 'no', edges: 'straight' };
      const messages = [];
      for (const [name, min, max] of [
        ['length',this.config.lengthMin ?? 600,this.config.lengthMax ?? 1200],
        ['depth',this.config.depthMin ?? 90,this.config.depthMax ?? 200]]) {
        const valid = Number.isInteger(s[name]) && s[name] >= min && s[name] <= max;
        field(name).setAttribute('aria-invalid', String(!valid));
        if (!valid) messages.push(this.text.invalid);
      }
      if (![26,30,35,40].includes(s.thickness)) messages.push(this.text.invalid_thickness);
      for (const name of ['skewLeft','skewRight']) {
        const valid = Number.isInteger(s[name]) && Math.abs(s[name]) <= 15;
        field(name).setAttribute('aria-invalid', String(!valid));
        if (!valid) messages.push(this.text.invalid_shape);
      }
      const price = this.querySelector('[data-price]');
      const fingerJoint = this.querySelector('[data-finger-joint]');
      if (fingerJoint) { fingerJoint.hidden = true; fingerJoint.textContent = ''; }
      price.textContent = '—';
      if (!messages.length) {
        const selected = this.querySelector('[data-wood]:checked')?.closest('label');
        try {
          if (!selected) throw Error(this.text.no_price);
          const wood = JSON.parse(selected.querySelector('[data-wood-config]').textContent);
          const missingPrice = !(Number(wood.woodPrice) > 0) && !wood.woodTiers?.some(t => Number(t.price) > 0);
          if (missingPrice) throw Error(this.text.no_price);
          const result = missingPrice ? null : window.HomConfiguratorCore.calculate({...this.config,...wood}, s);
          if (result && !Number.isFinite(result.cents)) throw Error(this.text.no_price);
          if (fingerJoint && result?.fingerJointCount > 0) {
            fingerJoint.textContent = this.text.finger_joint;
            fingerJoint.hidden = false;
          }
          price.textContent = missingPrice ? this.text.price_pending
            : new Intl.NumberFormat('nl-NL', {style:'currency',currency:'EUR'}).format(result.cents / 100);
          this.querySelector('[data-texture]').setAttribute('href', wood.texture);
          const textureId = this.querySelector('[data-texture]').parentElement.id;
          this.querySelector('[data-board]').setAttribute('fill', wood.texture ? 'url(#' + textureId + ')' : '#ded8c9');
          // Fixed viewport; scale the outline to the actual front, rear and depth.
          const scale = Math.min(540 / (s.length + Math.max(0,s.skewLeft) + Math.max(0,s.skewRight)), 170 / s.depth);
          const x = (600 - s.length * scale) / 2, y = (220 - s.depth * scale) / 2;
          this.querySelector('[data-board]').setAttribute('points', [
            [x-s.skewLeft*scale,y],[x+(s.length+s.skewRight)*scale,y],
            [x+s.length*scale,y+s.depth*scale],[x,y+s.depth*scale]
          ].map(p=>p.join(',')).join(' '));
          this.querySelector('[data-length]').textContent = s.length + ' mm';
          this.querySelector('[data-depth]').textContent = s.depth + ' mm';
          this.orderItem = {...s, kind:this.config.productKind,
            productId:String(wood.productId), woodId:wood.woodId, title:wood.productTitle,
            pickupOnly:wood.pickupOnly === true, unitCents:result.cents,
            finishLabel:this.querySelector('[data-finish]:checked').closest('label').textContent.trim(),
            edgeLabel:this.text.edge_label, fingerJointCount:result.fingerJointCount};
          this.querySelector('[data-add]').disabled = false;
        } catch (error) { messages.push(this.text.no_price); }
      }
      this.querySelector('[data-errors]').textContent = [...new Set(messages)].join(' ');
    }
  }
  customElements.define('hom-toilet-configurator', ToiletConfigurator);
})();



